import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Toast } from 'primeng/toast';

type FigmaAlertToastSeverity = 'success' | 'warn' | 'error' | string;

@Component({
  standalone: true,
  selector: 'app-figma-alert-toast',
  templateUrl: './figma-alert-toast.component.html',
  styleUrl: './figma-alert-toast.component.css',
  imports: [Toast, NgClass],
})
export class FigmaAlertToastComponent {
  @Input() toastKey?: string;

  @Input() position:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right'
    | 'center' = 'top-right';

  @Output() toastClose = new EventEmitter<{ message?: { data?: { alertId?: string } } }>();

  shellClass(severity: FigmaAlertToastSeverity): string {
    switch (severity) {
      case 'success':
        return 'figma-alert-toast-shell--success';
      case 'warn':
        return 'figma-alert-toast-shell--warning';
      default:
        return 'figma-alert-toast-shell--error';
    }
  }

  iconWrapClass(severity: FigmaAlertToastSeverity): string {
    switch (severity) {
      case 'success':
        return 'figma-alert-toast-icon-wrap--success';
      case 'warn':
        return 'figma-alert-toast-icon-wrap--warning';
      default:
        return 'figma-alert-toast-icon-wrap--error';
    }
  }

  titleClass(severity: FigmaAlertToastSeverity): string {
    switch (severity) {
      case 'success':
        return 'figma-alert-toast-title--success';
      case 'warn':
        return 'figma-alert-toast-title--warning';
      default:
        return 'figma-alert-toast-title--error';
    }
  }

  displaySummary(summary: string | undefined): string {
    const value = summary?.trim() ?? '';
    if (!value) {
      return 'Error!';
    }
    return value.endsWith('!') ? value : `${value}!`;
  }

  onToastClose(event: { message?: { data?: { alertId?: string } } }): void {
    this.toastClose.emit(event);
  }
}
